import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  isInitialised: false,
  user: null,

  loginIsLoading: false,
  loginSuccessful: false,
  loginError: null,

  registerIsLoading: false,
  registerSuccessful: false,
  registerError: null,

  activateAccountStatus: null,
  activateAccountIsLoading: false,
  activateAccountError: null,

  sendRecoverPasswordEmailIsLoading: false,
  recoverPasswordEmailSended: false,
  sendRecoverPasswordEmailerror: null,

  userTokenVerified: false,
  verifyUserTokenIsLoading: false,
  verifyUserTokenError: null,

  recoverPasswordIsLoading: false,
  passwordRecovered: false,
  recoverPasswordError: null
};

export const authSlice = createSlice({
  name: 'Auth',
  initialState,
  reducers: {
    activateAccountStart: state => {
      state.activateAccountStatus = null;
      state.activateAccountIsLoading = true;
      state.activateAccountError = null;
    },
    activateAccountSuccess: (state, { payload }) => {
      state.activateAccountStatus = payload.status;
      state.activateAccountIsLoading = false;
    },
    activateAccountError: (state, { payload }) => {
      state.activateAccountStatus = null;
      state.activateAccountIsLoading = false;
      state.activateAccountError = payload.error;
    },

    loginStart: state => {
      state.loginIsLoading = true;
      state.loginSuccessful = false;
      state.loginError = null;
    },
    loginSuccess: (state, { payload }) => {
      state.loginIsLoading = false;
      state.user = payload;
      state.isAuthenticated = true;
      state.loginSuccessful = true;
    },
    loginError: (state, { payload }) => {
      state.loginIsLoading = false;
      state.loginError = payload;
    },

    registerStart: state => {
      state.registerIsLoading = true;
      state.registerSuccessful = false;
      state.registerError = null;
    },
    registerSuccess: state => {
      state.registerIsLoading = false;
      state.registerSuccessful = true;
    },
    registerError: (state, { payload }) => {
      state.registerIsLoading = false;
      state.registerError = payload;
    },

    logout: state => {
      state.isAuthenticated = false;
      state.user = null;
      state.loginSuccessful = false;
      state.registerSuccessful = false;
    },

    resetAuth: state => {
      state.loginSuccessful = false;
      state.registerSuccessful = false;
    },

    verifyAccessTokenStart: state => {
      state.isAuthenticated = true;
      state.isInitialised = true;
    },
    verifyAccessTokenSuccess: (state, { payload }) => {
      state.isAuthenticated = true;
      state.isInitialised = false;
      state.user = payload;
    },
    verifyAccessTokenError: state => {
      state.isAuthenticated = false;
      state.isInitialised = false;
      state.user = null;
    },

    sendRecoverPasswordEmailStart: state => {
      state.sendRecoverPasswordEmailIsLoading = true;
      state.recoverPasswordEmailSended = false;
      state.sendRecoverPasswordEmailError = null;
    },
    sendRecoverPasswordEmailSuccess: state => {
      state.sendRecoverPasswordEmailIsLoading = false;
      state.recoverPasswordEmailSended = true;
    },
    sendRecoverPasswordEmailError: (state, { payload }) => {
      state.sendRecoverPasswordEmailIsLoading = false;
      state.sendRecoverPasswordEmailError = payload;
    },
    resetSendRecoverPasswordEmail: state => {
      state.sendRecoverPasswordEmailIsLoading = false;
      state.recoverPasswordEmailSended = false;
      state.sendRecoverPasswordEmailError = null;
    },

    verifyUserTokenStart: state => {
      state.verifyUserTokenIsLoading = true;
      state.userTokenVerified = false;
      state.verifyUserTokenError = null;
    },
    verifyUserTokenSuccess: state => {
      state.verifyUserTokenIsLoading = false;
      state.userTokenVerified = true;
      state.passwordRecovered = false;
    },
    verifyUserTokenError: (state, { payload }) => {
      state.verifyUserTokenIsLoading = false;
      state.verifyUserTokenError = payload;
    },

    recoverPasswordStart: state => {
      state.recoverPasswordIsLoading = true;
      state.passwordRecovered = false;
      state.recoverPasswordError = null;
    },
    recoverPasswordSuccess: state => {
      state.recoverPasswordIsLoading = false;
      state.passwordRecovered = true;
    },
    recoverPasswordError: (state, { payload }) => {
      state.recoverPasswordIsLoading = false;
      state.recoverPasswordError = payload;
    }
  }
});

export const {
  activateAccountStart,
  activateAccountSuccess,
  activateAccountError,
  loginStart,
  loginSuccess,
  loginError,
  registerStart,
  registerSuccess,
  registerError,
  logout,
  resetAuth,
  verifyAccessTokenStart,
  verifyAccessTokenSuccess,
  verifyAccessTokenError,
  sendRecoverPasswordEmailStart,
  sendRecoverPasswordEmailSuccess,
  sendRecoverPasswordEmailError,
  resetSendRecoverPasswordEmail,
  verifyUserTokenStart,
  verifyUserTokenSuccess,
  verifyUserTokenError,
  recoverPasswordStart,
  recoverPasswordSuccess,
  recoverPasswordError
} = authSlice.actions;

export default authSlice.reducer;
